const styles = (theme) => ({
    nameColor: {
        color: '#007bff',
        fontWeight: 500,
        fontSize: '14px'
    },
    agreementMargin: {
        marginLeft: '0% !important'
    },
    cancelButtonAlign: {
        paddingRight: '22px'
    },
    buttonAlign: {
        paddingBottom: '18px',
        paddingRight: '25px'
    },
    termsAlignDisplay: {
        height: '340px',
        width: '100%',
        overflowY: 'scroll',
        fontSize: '11px',
        borderStyle: 'solid',
        borderRadius: '5px',
        borderWidth: '1.5px',
        borderColor: '#007bff',
        paddingLeft: '6px',
        paddingRight: '4px'
    },
    termsAlign: {
        height: '340px',
        width: '96%',
        overflowY: 'scroll',
        fontSize: '11px',
        marginTop: '6px',
        marginBottom: '6px',
        borderStyle: 'solid',
        borderRadius: '5px',
        borderWidth: '1.5px',
        borderColor: '#007bff',
        paddingLeft: '6px',
        paddingRight: '4px'
    },
    errorTextAlign: {
        color: '#C81922',
        marginLeft: 48,
        marginTop: -15
    },
    helpText: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '0 !important',
        marginLeft: '-2%',
        fontStyle: 'italic'
    }
});
export default styles;
